// Tiny DOM helpers so the frontend has zero jQuery dependency.

/**
 * Run `fn` once the DOM is ready (or immediately if it already is).
 */
function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  }
}

/**
 * Delegated event binding. Relies on native event bubbling, so only use it for
 * events that bubble (click, change, input, submit, …).
 *
 * @param {Element} root
 * @param {string} type
 * @param {string} selector
 * @param {(event: Event, target: Element) => void} handler
 */
function delegate(root, type, selector, handler) {
  if (!root) return;
  root.addEventListener(type, (event) => {
    const target = event.target.closest(selector);
    if (target && root.contains(target)) {
      handler(event, target);
    }
  });
}

module.exports = { ready, delegate };
